<template>
 <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="isVisiable"
      width="min(900px, 94vw)"
      @close="doCancel"
    >
      <div class="template-editor-body">
      <el-form
        :model="dateForm"
        label-width="120px"
        class="add-role-form"
        :rules="dataRule"
        ref="formName"
      >
        <el-form-item label="模板类型：" prop="templateType">
            <el-select
                v-model="dateForm.templateType"
                placeholder="请选择"
                size="small"
                clearable
            >
                <el-option
                key="1"
                value="1"
                label="通用模板"
                ></el-option>
            </el-select>
        </el-form-item>
        <section class="language-section">
          <div class="language-section__heading">
            <span>多语言标题与内容</span>
            <div class="language-section__actions">
              <span class="language-section__hint">按客户端语言分别展示，译文可单独修改</span>
              <el-button type="primary" size="mini" :loading="translating" @click="translateFromChinese">自动翻译日英韩</el-button>
            </div>
          </div>
          <div class="language-grid">
            <div class="language-card">
              <div class="language-card__heading"><strong>中文</strong><span>ZH</span></div>
              <el-form-item label="标题" prop="remindingTitle" label-width="56px">
                <el-input v-model="dateForm.remindingTitle" size="small" maxlength="100" show-word-limit placeholder="请输入中文标题"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="remindingContent" label-width="56px">
                <el-input v-model="dateForm.remindingContent" type="textarea" placeholder="请输入中文内容" :autosize="{ minRows: 4, maxRows: 7 }"></el-input>
              </el-form-item>
            </div>
            <div class="language-card">
              <div class="language-card__heading"><strong>日语</strong><span>JA</span></div>
              <el-form-item label="标题" prop="remindingTitleJa" label-width="56px">
                <el-input v-model="dateForm.remindingTitleJa" size="small" maxlength="100" show-word-limit placeholder="请输入日语标题"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="remindingContentJa" label-width="56px">
                <el-input v-model="dateForm.remindingContentJa" type="textarea" placeholder="请输入日语内容" :autosize="{ minRows: 4, maxRows: 7 }"></el-input>
              </el-form-item>
            </div>
            <div class="language-card">
              <div class="language-card__heading"><strong>英语</strong><span>EN</span></div>
              <el-form-item label="标题" prop="remindingTitleEn" label-width="56px">
                <el-input v-model="dateForm.remindingTitleEn" size="small" maxlength="100" show-word-limit placeholder="Enter an English title"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="remindingContentEn" label-width="56px">
                <el-input v-model="dateForm.remindingContentEn" type="textarea" placeholder="Enter English content" :autosize="{ minRows: 4, maxRows: 7 }"></el-input>
              </el-form-item>
            </div>
            <div class="language-card">
              <div class="language-card__heading"><strong>韩语</strong><span>KO</span></div>
              <el-form-item label="标题" prop="remindingTitleKo" label-width="56px">
                <el-input v-model="dateForm.remindingTitleKo" size="small" maxlength="100" show-word-limit placeholder="한국어 제목을 입력하세요"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="remindingContentKo" label-width="56px">
                <el-input v-model="dateForm.remindingContentKo" type="textarea" placeholder="한국어 내용을 입력하세요" :autosize="{ minRows: 4, maxRows: 7 }"></el-input>
              </el-form-item>
            </div>
          </div>
        </section>

        <el-form-item label="跳转链接：">
            <el-input
                v-model="dateForm.url"
                size="small"
                placeholder="填入与消息内容中存在且相同的网址链接，可让对应链接实现点击跳转，多个链接用“,”隔开。"
            ></el-input>
        </el-form-item>

        <el-form-item label="模板说明：">
            <el-input
                v-model="dateForm.remindingNotes"
                type="textarea"
                placeholder="请输入"
                :maxlength="500"
                :autosize="{ minRows: 4}"
            ></el-input>
        </el-form-item>
      </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="doCancel">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="doConfirm">保 存</el-button>
      </span>
    </el-dialog>
</template>
<script>
const dateForm = {
    id: '',
    templateType: "", // 模板类型
    remindingTitle: "", // 中文标题
    remindingContent: '', // 中文内容
    remindingTitleJa: '', // 日文标题
    remindingContentJa: '', // 模板内容日文
    remindingTitleEn: '',
    remindingContentEn: '',
    remindingTitleKo: '',
    remindingContentKo: '',
    url: '',// 跳转链接
    remindingNotes: ''// 模板说明
}
export default {
  name: "EditTemp",
  props: {
      isVisiable: {
          type: Boolean,
          default: false
      },
      id: {
          type: [String , Number] ,
          default: ''
      }
  },
  data () {
    return {
        dateForm: this._.cloneDeep(dateForm),
        translating: false,
        dataRule: {
            templateType: [
                { required: true, message: "请选择模板类型", trigger: "change" },
            ],
            remindingTitle: [
                { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
            ],
            remindingContent: [
                { required: true, message: "请输入中文内容", trigger: "blur" },
            ],
            remindingTitleJa: [
                { required: true, message: "请输入至少1个字符，最多100个字符！", trigger: "blur" },
            ],
            remindingContentJa: [
                { required: true, message: "必须输入模板内容,请输入日文！", trigger: "blur" },
            ],
            remindingTitleEn: [{ required: true, message: "请输入英文标题", trigger: "blur" }],
            remindingContentEn: [{ required: true, message: "请输入英文内容", trigger: "blur" }],
            remindingTitleKo: [{ required: true, message: "请输入韩文标题", trigger: "blur" }],
            remindingContentKo: [{ required: true, message: "请输入韩文内容", trigger: "blur" }],
        },
    };
  },
  watch: {
      id(val) {
          if(val) {
              this.dateForm.id = val
              this.getDetail()
          } else {
              this.dateForm = this._.cloneDeep(dateForm)
          }
      },
      isVisiable(val){
          if (val && this.dateForm.id != ''){
            this.getDetail()
          }
      }
  },
    methods: {
        async translateFromChinese() {
            const title = (this.dateForm.remindingTitle || '').trim()
            const content = (this.dateForm.remindingContent || '').trim()
            if (!title || !content) {
                this.$message.warning('请先填写中文标题和内容')
                return
            }
            const targetFields = ['remindingTitleJa', 'remindingContentJa', 'remindingTitleEn', 'remindingContentEn', 'remindingTitleKo', 'remindingContentKo']
            if (targetFields.some(field => (this.dateForm[field] || '').trim())) {
                try {
                    await this.$confirm('自动翻译将覆盖已有的日、英、韩内容，是否继续？', '确认覆盖', { type: 'warning' })
                } catch (_) {
                    return
                }
            }
            this.translating = true
            try {
                const { data: res } = await this.$http.post('/template/message/translate', { title, content })
                if (res.code !== 200 || !res.data) {
                    this.$message.error(res.message || '翻译失败')
                    return
                }
                const translated = res.data
                for (const [language, suffix] of [['ja', 'Ja'], ['en', 'En'], ['ko', 'Ko']]) {
                    this.dateForm[`remindingTitle${suffix}`] = translated[language].title
                    this.dateForm[`remindingContent${suffix}`] = translated[language].content
                }
                this.$message.success('翻译完成，请核对后保存')
            } catch (_) {
                this.$message.error('翻译失败，请稍后重试')
            } finally {
                this.translating = false
            }
        },
        getDetail () {
            this.$http.get(`/template/message/${this.id}`, {}).then(res => {
                let info = res.data.data
                Object.keys(this.dateForm).forEach(key => {
                    this.dateForm[key] = info[key]
                })
            })
        },
        doConfirm() {
            const self = this;
            this.$refs.formName.validate(async function (valid) {
                if (valid) {
                    const { data: res } = await self.$http.post(
                        "/template/message/save",
                        self.dateForm
                    );
                    if (res.code == 200) {
                        self.$message({
                            type: "success",
                            message: res.message,
                        });
                        self.$emit('confirm')
                    } else {
                        self.$message.error(res.message);
                    }
                }
            });
        },
        doCancel() {
            this.$emit('update:isVisiable', false)
        },
        doReset() {

        }
    }
}
</script>
<style scoped>
.template-editor-body {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  padding-right: 8px;
}

.language-section {
  margin: 8px 0 22px;
}

.language-section__heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.language-section__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.language-section__hint {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.language-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.language-card {
  min-width: 0;
  padding: 16px 16px 0;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: #fafbfc;
}

.language-card__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
  color: #303133;
}

.language-card__heading span {
  font-size: 12px;
  color: #909399;
}

@media (max-width: 760px) {
  .language-grid {
    grid-template-columns: 1fr;
  }
}
</style>
